class ModificarContrasena {
    constructor(actualPass, newPass, newPassRep, userNumber) {
        this.actualPass = actualPass;
        this.newPass = newPass;
        this.newPassRep = newPassRep;
        this.userNumber = userNumber;
    }
}

export default ModificarContrasena;